export class SumupGroup {
  exec_date: string = null
  name: string = null
  assessment_score_type: number

  constructor(x: any){
    this.exec_date = x.exec_date;
    this.name = x.name;
  }
}

export class SumupUnit {
  id: number
  name: string
  sumup_unit_ids: number[]
  score_bunpu_range: string
  result_published: boolean
  sort_no: string
}

export class BaseSumupUnit {
  id: number
  name: string
}